<template>
  <el-dialog
    :title="$t('config.profile.title.invoiceCom')"
    :visible.sync="dialogFormVisible"
    width="70%"
    :close-on-click-modal="false"
    @close="invoiceCompanyForm = { ...defaultInvoiceCompanyForm }"
  >
    <validation-observer ref="formValidator">
      <div class="das-form-container datnt">
        <div class="das-form-group" style="margin-bottom: 0">
          <div class="das-form-row">
            <div class="das-form-col col-6">
              <validation-provider
                tag="div"
                class="das-form-input"
                rules="required"
                name="Mã số thuế"
              >
                <div class="label required">
                  {{ $t('config.profile.field.taxCode') }}
                </div>
                <div class="child-w-80">
                  <input
                    v-model="invoiceCompanyForm.code"
                    type="text"
                    placeholder=""
                  />
                </div>
              </validation-provider>
            </div>
          </div>
          <div class="das-form-row">
            <div class="das-form-col col-12">
              <validation-provider
                tag="div"
                class="das-form-input"
                rules="required"
                name="Tên công ty"
              >
                <div class="label required">
                  {{ $t('config.profile.field.companyName') }}
                </div>
                <div class="child-w-80">
                  <input
                    v-model="invoiceCompanyForm.name"
                    type="text"
                    placeholder=""
                  />
                </div>
              </validation-provider>
            </div>
          </div>
          <div class="das-form-row">
            <div class="das-form-col col-12">
              <validation-provider
                tag="div"
                class="das-form-input"
                rules="required"
                name="Địa chỉ"
              >
                <div class="label required">
                  {{ $t('config.profile.field.address') }}
                </div>
                <div class="child-w-80">
                  <input
                    v-model="invoiceCompanyForm.address"
                    type="text"
                    placeholder=""
                  />
                </div>
              </validation-provider>
            </div>
          </div>
          <div class="das-form-row">
            <div class="das-form-col col-6">
              <validation-provider
                tag="div"
                class="das-form-input"
                :rules="`phoneNumber:${vueTelIso2.phone_number},${vueTelDialCode.phone_number}`"
                name="Số điện thoại"
              >
                <div class="label">{{ $t('config.profile.field.phone') }}</div>
                <div class="child-w-80">
                  <tel-input
                    v-model="invoiceCompanyForm.phone_number"
                    @country-changed="countryChange"
                  />
                  <!-- <vue-tel-input
                    v-model="invoiceCompanyForm.phone_number"
                    v-numeric-only
                    default-country="VN"
                    :input-options="vueTelOptions"
                    @country-changed="countryChange"
                  /> -->
                </div>
              </validation-provider>
            </div>
            <div class="das-form-col col-6">
              <validation-provider
                tag="div"
                class="das-form-input"
                rules="email"
                name="Email"
              >
                <div class="label">{{ $t('config.profile.field.email') }}</div>
                <div class="child-w-80">
                  <input
                    v-model="invoiceCompanyForm.email"
                    type="text"
                    placeholder=""
                  />
                </div>
              </validation-provider>
            </div>
          </div>
          <div class="das-form-row">
            <div class="das-form-col col-6">
              <validation-provider
                tag="div"
                class="das-form-input"
                rules=""
                name="Tên ngân hàng"
              >
                <div class="label">
                  {{ $t('config.profile.field.bankName') }}
                </div>
                <div class="child-w-80">
                  <input
                    v-model="invoiceCompanyForm.bank_name"
                    type="text"
                    placeholder=""
                  />
                </div>
              </validation-provider>
            </div>
            <div class="das-form-col col-6">
              <validation-provider
                tag="div"
                class="das-form-input"
                rules=""
                name="Số tài khoản"
              >
                <div class="label">
                  {{ $t('config.profile.field.bankNumber') }}
                </div>
                <div class="child-w-80">
                  <input
                    v-model="invoiceCompanyForm.bank_account_number"
                    type="text"
                    placeholder=""
                  />
                </div>
              </validation-provider>
            </div>
          </div>
          <div class="das-form-row">
            <div class="das-form-col col-12">
              <validation-provider
                tag="div"
                class="das-form-input"
                rules=""
                name="Ghi chú"
              >
                <div class="label">{{ $t('config.profile.field.note') }}</div>
                <div class="child-w-80">
                  <textarea
                    v-model="invoiceCompanyForm.note"
                    rows="2"
                    style="resize: none"
                    type="text"
                    placeholder=""
                  />
                </div>
              </validation-provider>
            </div>
          </div>
        </div>
      </div>
    </validation-observer>

    <span slot="footer" class="dialog-footer">
      <div class="button-containers">
        <button
          class="btn primary small outline"
          @click="
            invoiceCompanyForm = { ...defaultInvoiceCompanyForm }
            dialogFormVisible = false
          "
        >
          {{ $t('config.profile.common.cancel') }}
        </button>
        <button
          v-if="isEdit"
          class="btn primary small"
          @click="updateInvoiceCompany"
        >
          {{ $t('config.profile.common.update') }}
        </button>
        <button v-else class="btn primary small" @click="addInvoiceCompany">
          {{ $t('config.profile.common.create') }}
        </button>
      </div>
    </span>
  </el-dialog>
</template>

<script>
import {
  addInvoiceCompanyApi,
  getInvoiceCompanyByIdApi,
  updateInvoiceCompanyApi
} from '@/api/configuration/profile/invoiceCompany'
export default {
  components: {},
  props: {
    value: {
      type: Boolean,
      default: false
    },
    profileId: {
      type: Number,
      default: null
    },
    isEdit: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      invoiceCompanyForm: {
        code: null,
        email: null,
        name: null,
        address: null,
        note: null,
        phone_number: null,
        bank_name: null,
        bank_account_number: null
      },
      defaultInvoiceCompanyForm: {
        code: null,
        email: null,
        name: null,
        address: null,
        note: null,
        phone_number: null,
        bank_name: null,
        bank_account_number: null
      },

      vueTelOptions: {
        showDialCode: true,
        placeholder: 'Số điện thoại'
      },
      vueTelDialCode: {
        phone_number: null
      },
      vueTelIso2: {
        phone_number: null
      },

      dialogFormVisible: this.value
    }
  },

  watch: {
    value(nv, ov) {
      this.dialogFormVisible = nv
    },
    dialogFormVisible(nv, ov) {
      if (!nv) {
        this.$emit('input', nv)
      }
    },
    isEdit(nv, ov) {
      if (nv) {
        this.fnGetInvoiceCompanyById()
      }
    }
  },

  methods: {
    // btn event
    async addInvoiceCompany() {
      if ((await this.$vxForm.isValid(this.$refs.formValidator)) === false) {
        return
      }
      const data = {
        ...this.invoiceCompanyForm,
        phone_number:
          this.invoiceCompanyForm.phone_number ===
          this.vueTelDialCode.phone_number
            ? null
            : this.invoiceCompanyForm.phone_number
      }

      this.fnAddInvoiceCompany(data)
    },
    async updateInvoiceCompany() {
      if ((await this.$vxForm.isValid(this.$refs.formValidator)) === false) {
        return
      }
      const data = {
        ...this.invoiceCompanyForm,
        phone_number:
          this.invoiceCompanyForm.phone_number ===
          this.vueTelDialCode.phone_number
            ? null
            : this.invoiceCompanyForm.phone_number
      }

      this.fnUpdateInvoiceCompany(data)
    },

    countryChange(param) {
      this.vueTelIso2.phone_number = param.iso2
      this.vueTelDialCode.phone_number = `+${param.dialCode}`
    },

    // handle api call
    async fnAddInvoiceCompany(data) {
      try {
        const res = await addInvoiceCompanyApi(data)
        if (!res.is_error) {
          //
          this.$message({
            type: 'success',
            message: this.$t(`successMsg.${res.message}`)
          })
          // close the dialog and reset search
          this.invoiceCompanyForm = { ...this.defaultInvoiceCompanyForm }
          this.dialogFormVisible = false
          this.$emit('resetSearch')
        } else {
          throw new Error(res)
        }
      } catch (error) {
        const message = error.response?.data?.message || 'default'
        this.$message({
          type: 'error',
          message: this.$t(`errorMsg.${message}`)
        })
      } finally {
        //
      }
    },

    // for update
    async fnGetInvoiceCompanyById() {
      if (!this.profileId || !this.isEdit) {
        this.$message({
          type: 'error',
          message: this.$t('config.profile.message.idNotFound')
        })
        this.invoiceCompanyForm = { ...this.defaultInvoiceCompanyForm }
        this.dialogFormVisible = false
        return
      }
      try {
        const res = await getInvoiceCompanyByIdApi({ id: this.profileId })
        if (!res.is_error) {
          this.invoiceCompanyForm = { ...res.data }
          if (!this.invoiceCompanyForm.phone_number) {
            this.invoiceCompanyForm.phone_number =
              this.vueTelDialCode.phone_number
          }
        } else {
          throw new Error(res)
        }
      } catch (error) {
        const message = error.response?.data?.message || 'default'
        this.$message({
          type: 'error',
          message: this.$t(`errorMsg.${message}`)
        })
      } finally {
        //
      }
    },
    async fnUpdateInvoiceCompany(data) {
      try {
        const res = await updateInvoiceCompanyApi(data)
        if (!res.is_error) {
          //
          this.$message({
            type: 'success',
            message: this.$t(`successMsg.${res.message}`)
          })
          // close the dialog and reset search
          this.invoiceCompanyForm = { ...this.defaultInvoiceCompanyForm }
          this.dialogFormVisible = false
          this.$emit('resetSearch')
        } else {
          throw new Error(res)
        }
      } catch (error) {
        const message = error.response?.data?.message || 'default'
        this.$message({
          type: 'error',
          message: this.$t(`errorMsg.${message}`)
        })
      } finally {
        //
      }
    }
  }
}
</script>
